<template>
    <div class="popup-panel">
        <opportunity-form
            v-if="opportunity.display"
            v-bind="opportunity.props"
            @close="close({ key: 'opportunityForm' })"
        />

        <address-form
            v-if="address.display"
            v-bind="address.props"
            @close="close({ key: 'addressForm' })"
        />

        <customfields-form
            v-if="customfield.display"
            v-bind="customfield.props"
            @close="close({ key: 'customfieldForm' })"
        />

        <document-preview
            v-if="document.display"
            v-bind="document.props"
            @close="close({ key: 'documentPreview' })"
        />

        <email-onboarding
            v-if="emailOnboarding.display"
            v-bind="emailOnboarding.props"
            @close="close({ key: 'emailOnboarding' })"
        />

        <email-connection-failed
            v-if="emailConnectionfailed.display"
            v-bind="emailConnectionfailed.props"
            @close="close({ key: 'emailConnectionfailed' })"
        />

        <add-recurring-term-component
            v-if="addRecurringTerm.display"
            v-bind="addRecurringTerm.props"
            @close="close({ key: 'addRecurringTerm' })"
        />

        <change-owner-component
            v-if="changeOwner.display"
            v-bind="changeOwner.props"
            @close="close({ key: 'changeOwner' })"
        />

        <change-generation-mode-component
            v-if="changeGenerationMode.display"
            v-bind="changeGenerationMode.props"
            @close="close({ key: 'changeGenerationMode' })"
        />

        <document-validation
            v-if="documentValidation.display"
            v-bind="documentValidation.props"
            @close="close({ key: 'documentValidation' })"
        />

        <avatar-uploader
            v-if="avatarUploader.display"
            v-bind="avatarUploader.props"
            @close="close({ key: 'avatarUploader' })"
        />

        <popup-april-team-position
            v-if="popupAprilTeamPosition.display"
            v-bind="popupAprilTeamPosition.props"
            @close="close({ key: 'popupAprilTeamPosition' })"
        />

        <transfer-transaction-form
            v-if="transferTransactionForm.display"
            @close="close({ key: 'transferTransactionForm' })"
        />

        <calendar-view
            v-if="calendarView.display"
            v-bind="calendarView.props"
            @close="close({ key: 'calendarView' })"
        />

        <staff-form
            v-if="staffForm.display"
            v-bind="staffForm.props"
            @close="close({ key: 'staffForm' })"
        />

        <popup-quota-limit
            v-if="popupQuotaLimit.display"
            v-bind="popupQuotaLimit.props"
            @close="close({ key: 'popupQuotaLimit' })"
        />

        <popup-mailchimp-settings
            v-if="popupMailchimpSettings.display"
            v-bind="popupMailchimpSettings.props"
            @close="close({ key: 'popupMailchimpSettings' })"
        />

        <popup-mailjet-settings
            v-if="popupMailjetSettings.display"
            v-bind="popupMailjetSettings.props"
            @close="close({ key: 'popupMailjetSettings' })"
        />

        <popup-third-form
            v-if="popupThirdForm.display"
            v-bind="popupThirdForm.props"
            :closeOnClickModal="false"
            @close="close({ key: 'popupThirdForm' })"
        />

        <popup-warning-third-form
            v-if="popupWarningThirdForm.display"
            v-bind="popupWarningThirdForm.props"
            :closeOnClickModal="false"
            @close="close({ key: 'popupWarningThirdForm' })"
        />

        <popup-mass-edit-prefs
            v-if="popupMassEditPrefs.display"
            v-bind="popupMassEditPrefs.props"
            @close="close({ key: 'popupMassEditPrefs' })"
        />

        <popup-mass-edit-vat-mode
            v-if="popupMassEditVatMode.display"
            v-bind="popupMassEditVatMode.props"
            @close="close({ key: 'popupMassEditVatMode' })"
        />

        <popup-scheduler-settings
            v-if="popupSchedulerSettings.display"
            v-bind="popupSchedulerSettings.props"
            @close="close({ key: 'popupSchedulerSettings' })"
        />

        <esign-popup-provider
            v-if="esignPopupProvider.display"
            v-bind="esignPopupProvider.props"
            @close="close({ key: 'esignPopupProvider' })"
        />

        <popup-manager-payment-card
            v-if="popupManagerPaymentCard.display"
            v-bind="popupManagerPaymentCard.props"
            @close="close({ key: 'popupManagerPaymentCard' })"
        />

        <Corp2FAToggle
            v-if="corp2FAToggle.display"
            v-bind="corp2FAToggle.props"
            @close="close({ key: 'corp2FAToggle' })"
        />

        <BackupCodes2FA
            v-if="backupCodes2FA.display"
            v-bind="backupCodes2FA.props"
            @close="close({ key: 'backupCodes2FA' })"
        />

        <Deactivate2FA
            v-if="deactivate2FA.display"
            v-bind="deactivate2FA.props"
            @close="close({ key: 'deactivate2FA' })"
        />

        <RemoveTrustedDevice
            v-if="removeTrustedDevice.display"
            v-bind="removeTrustedDevice.props"
            @close="close({ key: 'removeTrustedDevice' })"
        />

        <Activate2FAProvider
            v-if="activate2FAProvider.display"
            v-bind="activate2FAProvider.props"
            @close="close({ key: 'activate2FAProvider' })"
        />

        <AdyenPopup
            v-if="adyenPopup.display"
            v-bind="adyenPopup.props"
            @close="close({ key: 'adyenPopup' })"
        />

        <CashflowPopupWarning
            v-if="cashflowPopupWarning.display"
            v-bind="cashflowPopupWarning.props"
            @close="close({ key: 'cashflowPopupWarning' })"
        />

        <PopupCheckSendingEmail
            v-if="popupCheckSendingEmail.display"
            v-bind="popupCheckSendingEmail.props"
            @close="close({ key: 'popupCheckSendingEmail' })"
        />
        <ImportRevertPopup
            v-if="importRevertPopup.display"
            v-bind="importRevertPopup.props"
            @closed="close({ key: 'importRevertPopup' })"
        />
        <ImportCancelPopup
            v-if="importCancelPopup.display"
            v-bind="importCancelPopup.props"
            @closed="close({ key: 'importCancelPopup' })"
        />
        <ImportDetailPopup
            v-if="importDetailPopup.display"
            v-bind="importDetailPopup.props"
            @closed="close({ key: 'importDetailPopup' })"
        />

        <OnboardingScreenPanel
            v-if="onboardingScreenPanel.display"
            v-bind="onboardingScreenPanel.props"
            @close="close({ key: 'onboardingScreenPanel' })"
        />

        <UpsellFeatureModal
            v-if="featureModal.display"
            v-bind="featureModal.props"
            @close="close({ key: 'featureModal' })"
        />

        <AICancelModal
            v-if="aiCancelModal.display"
            v-bind="aiCancelModal.props"
            @close="close({ key: 'aiCancelModal' })"
        />
        <ActivityFormPanel
            v-if="activityFormPanel.display"
            v-bind="activityFormPanel.props"
            @close="close({ key: 'activityFormPanel' })"
        />
        <PhoneCallFormPanel
            v-if="phoneCallFormPanel.display"
            v-bind="phoneCallFormPanel.props"
            @close="close({ key: 'phoneCallFormPanel' })"
        />
        <ActivityDetailPanel
            v-if="activityDetailPanel.display"
            v-bind="activityDetailPanel.props"
            @close="close({ key: 'activityDetailPanel' })"
        />
        <ActivityDeleteDialog
            v-if="activityDeleteDialog.display"
            v-bind="activityDeleteDialog.props"
            @close="close({ key: 'activityDeleteDialog' })"
        />
        <ActivitiesListingMassReschedule
            v-if="activitiesListingMassReschedule.display"
            v-bind="activitiesListingMassReschedule.props"
            @close="close({ key: 'activitiesListingMassReschedule' })"
        />
        <PopupMarkPhoneCallDone
            v-if="popupMarkPhoneCallDone.display"
            v-bind="popupMarkPhoneCallDone.props"
            @close="close({ key: 'popupMarkPhoneCallDone' })"
        />
        <ActivitiesMassMarkAsDone
            v-if="activitiesMassMarkAsDone.display"
            v-bind="activitiesMassMarkAsDone.props"
            @close="close({ key: 'activitiesMassMarkAsDone' })"
        />
        <ActivitiesListingMassModifyOwner
            v-if="activitiesListingMassModifyOwner.display"
            v-bind="activitiesListingMassModifyOwner.props"
            @close="close({ key: 'activitiesListingMassModifyOwner' })"
        />
        <ActivitiesListingMassAssign
            v-if="activitiesListingMassAssign.display"
            v-bind="activitiesListingMassAssign.props"
            @close="close({ key: 'activitiesListingMassAssign' })"
        />
        <ActivitiesListingMassDelete
            v-if="activitiesListingMassDelete.display"
            v-bind="activitiesListingMassDelete.props"
            @close="close({ key: 'activitiesListingMassDelete' })"
        />
        <MyActivitiesCardConfigDialog
            v-if="myActivitiesCardConfigDialog.display"
            v-bind="myActivitiesCardConfigDialog.props"
            @close="close({ key: 'myActivitiesCardConfigDialog' })"
        />
        <ConnectionConsentDialog
            v-if="connectionConsentDialog.display"
            v-bind="connectionConsentDialog.props"
            @close="close({ key: 'connectionConsentDialog' })"
        />
        <ActivitiesLinkObjectDialog
            v-if="activitiesLinkObjectDialog.display"
            v-bind="activitiesLinkObjectDialog.props"
            @close="close({ key: 'activitiesLinkObjectDialog' })"
        />
        <CreateProgressInvoiceBlockByDraftDialog
            v-if="createProgressInvoiceBlockByDraftDialog.display"
            v-bind="createProgressInvoiceBlockByDraftDialog.props"
            @close="close({ key: 'createProgressInvoiceBlockByDraftDialog' })"
        />
        <DialogValidateProgressInvoice
            v-if="dialogValidateProgressInvoice.display"
            v-bind="dialogValidateProgressInvoice.props"
            @close="close({ key: 'dialogValidateProgressInvoice' })"
        />
        <CancelProgressInvoiceDialog
            v-if="cancelProgressInvoiceDialog.display"
            v-bind="cancelProgressInvoiceDialog.props"
            @close="close({ key: 'cancelProgressInvoiceDialog' })"
        />
        <EmailListingDeleteConfirmDialog
            v-if="emailDeleteConfirmDialog.display"
            v-bind="emailDeleteConfirmDialog.props"
            @close="close({ key: 'emailDeleteConfirmDialog' })"
        />
        <DocumentHasProgressInvoiceDialog
            v-if="documentHasProgressInvoiceDialog.display"
            v-bind="documentHasProgressInvoiceDialog.props"
            @close="close({ key: 'documentHasProgressInvoiceDialog' })"
        />
        <AlertDialog v-if="alert.display" v-bind="alert.props" @close="close({ key: 'alert' })" />
        <DialogMissingFeaturesProgressInvoice
            v-if="dialogMissingFeaturesProgressInvoice.display"
            v-bind="dialogMissingFeaturesProgressInvoice.props"
            @close="close({ key: 'dialogMissingFeaturesProgressInvoice' })"
        />
        <DialogProgressInvoiceSelectType
            v-if="dialogProgressInvoiceSelectType.display"
            v-bind="dialogProgressInvoiceSelectType.props"
            @close="close({ key: 'dialogProgressInvoiceSelectType' })"
        />
        <ContactPanel
            v-if="contactPanel.display"
            v-bind="contactPanel.props"
            @close="close({ key: 'contactPanel' })"
        />
        <AutomationDeleteDialog
            v-if="automationDeleteDialog.display"
            v-bind="automationDeleteDialog.props"
            @close="close({ key: 'automationDeleteDialog' })"
        />
        <DocFormErrorDialog
            v-if="docFormErrorDialog.display"
            v-bind="docFormErrorDialog.props"
            @close="close({ key: 'docFormErrorDialog' })"
        />
        <DialogDocumentNotAuthorized
            v-if="documentNotAuthorized.display"
            v-bind="documentNotAuthorized.props"
            @close="close({ key: 'documentNotAuthorized' })"
        />
    </div>
</template>
<script>
import OpportunityForm from 'vcomponents/forms/OpportunityForm.vue';
import AddressForm from 'vcomponents/forms/AddressForm.vue';
import DocumentPreview from 'vcomponents/DocumentPreview.vue';
import CustomfieldsForm from 'vcomponents/forms/CustomfieldsForm.vue';
import EmailOnboarding from 'vcomponents/email/EmailOnboardingSidePanel.vue';
import EmailConnectionFailed from 'vcomponents/email/EmailConnectionFailed.vue';
import AddRecurringTermComponent from './listing/batchComponents/AddRecurringTermComponent.vue';
import ChangeOwnerComponent from 'vcomponents/listing/batchComponents/ChangeOwnerComponent.vue';
import ChangeGenerationModeComponent from 'vcomponents/listing/batchComponents/ChangeGenerationModeComponent.vue';
import PopupAprilTeamPosition from 'vcomponents/PopupAprilTeamPosition.vue';
import DocumentValidation from 'vcomponents/listing/batchComponents/DocumentValidation.vue';
import AvatarUploader from 'vcomponents/utilities/AvatarUploader.vue';
import TransferTransactionForm from 'vcomponents/bankreconciliation/TransferTransactionForm.vue';
import CalendarView from 'vcomponents/utilities/CalendarView.vue';
import StaffForm from 'vcomponents/forms/StaffForm.vue';
import PopupQuotaLimit from 'vcomponents/quotas/PopupQuotaLimit.vue';
import PopupMailchimpSettings from 'vcomponents/popups/PopupMailchimpSettings.vue';
import PopupMailjetSettings from 'vcomponents/popups/PopupMailjetSettings.vue';
import PopupThirdForm from 'vcomponents/forms/popups/PopupThirdForm.vue';
import PopupWarningThirdForm from 'vcomponents/forms/popups/PopupWarningThirdForm.vue';
import PopupMassEditPrefs from 'vcomponents/forms/PopupMassEditPrefs.vue';
import PopupMassEditVatMode from 'vcomponents/forms/PopupMassEditVatMode.vue';
import PopupSchedulerSettings from 'vcomponents/popups/PopupSchedulerSettings.vue';
import EsignPopupProvider from 'vcomponents/esign/EsignPopupProvider.vue';
import PopupManagerPaymentCard from 'vcomponents/popups/PopupManagerPaymentCard.vue';
import Corp2FAToggle from 'vcomponents/popups/Corp2FAToggle.vue';
import BackupCodes2FA from 'vcomponents/popups/BackupCodes2FA.vue';
import Deactivate2FA from 'vcomponents/popups/Deactivate2FA.vue';
import RemoveTrustedDevice from 'vcomponents/popups/RemoveTrustedDevice.vue';
import Activate2FAProvider from 'vcomponents/popups/Activate2FAProvider.vue';
import AdyenPopup from 'vcomponents/settings/adyen/AdyenPopup.vue';
import CashflowPopupWarning from 'vcomponents/popups/CashflowPopupWarning.vue';
import PopupCheckSendingEmail from 'vcomponents/popups/PopupCheckSendingEmail.vue';
import ImportDetailPopup from 'vcomponents/settings/import/detail/ImportDetailPopup.vue';
import ImportRevertPopup from 'vcomponents/settings/import/ImportRevertPopup.vue';
import ImportCancelPopup from 'vcomponents/settings/import/ImportCancelPopup.vue';
import OnboardingScreenPanel from 'vcomponents/onboarding/OnboardingScreenPanel.vue';
import ActivityFormPanel from 'vcomponents/activities/activitiesFormPanel/ActivityFormPanel.vue';
import PhoneCallFormPanel from 'vcomponents/activities/activitiesFormPanel/PhoneCallFormPanel.vue';
import UpsellFeatureModal from './UpsellFeatureModal.vue';
import ActivityDetailPanel from 'vcomponents/activities/detailPanel/ActivityDetailPanel.vue';
import AICancelModal from './richtext/AICancelModal.vue';
import ActivityDeleteDialog from 'vcomponents/activities/dialog/ActivityDeleteDialog.vue';
import ActivitiesListingMassReschedule from 'vcomponents/activities/listing/massActions/ActivitiesListingMassReschedule.vue';
import PopupMarkPhoneCallDone from 'vcomponents/activities/popupMarkPhoneCallDone.vue';
import ActivitiesMassMarkAsDone from 'vcomponents/activities/listing/massActions/ActivitiesMassMarkAsDone.vue';
import ActivitiesListingMassModifyOwner from 'vcomponents/activities/listing/massActions/ActivitiesListingMassModifyOwner.vue';
import ActivitiesListingMassAssign from 'vcomponents/activities/listing/massActions/ActivitiesListingMassAssign.vue';
import ActivitiesListingMassDelete from 'vcomponents/activities/listing/massActions/ActivitiesListingMassDelete.vue';
import MyActivitiesCardConfigDialog from 'vcomponents/dashboard/cards/MyActivitiesCardConfigDialog.vue';
import ConnectionConsentDialog from 'vcomponents/sellsyadmin/ConnectionConsentDialog.vue';
import ActivitiesLinkObjectDialog from 'vcomponents/activities/dialog/activitiesLinkObject/ActivitiesLinkObjectDialog.vue';
import EmailListingDeleteConfirmDialog from 'vcomponents/email/listings/EmailListingDeleteConfirmDialog.vue';
import AlertDialog from 'vcomponents/common/alert/AlertDialog.vue';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapState = createNamespacedHelpers('popupPanel').mapState;
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        PopupMarkPhoneCallDone,
        EsignPopupProvider,
        PopupManagerPaymentCard,
        PopupSchedulerSettings,
        OpportunityForm,
        AddressForm,
        DocumentPreview,
        CustomfieldsForm,
        EmailOnboarding,
        EmailConnectionFailed,
        AddRecurringTermComponent,
        ChangeOwnerComponent,
        ChangeGenerationModeComponent,
        PopupAprilTeamPosition,
        DocumentValidation,
        AvatarUploader,
        TransferTransactionForm,
        CalendarView,
        StaffForm,
        PopupQuotaLimit,
        PopupMailchimpSettings,
        PopupMailjetSettings,
        PopupWarningThirdForm,
        PopupThirdForm,
        PopupMassEditPrefs,
        PopupMassEditVatMode,
        Corp2FAToggle,
        BackupCodes2FA,
        Deactivate2FA,
        RemoveTrustedDevice,
        Activate2FAProvider,
        AdyenPopup,
        CashflowPopupWarning,
        PopupCheckSendingEmail,
        ImportDetailPopup,
        ImportRevertPopup,
        ImportCancelPopup,
        OnboardingScreenPanel,
        UpsellFeatureModal,
        AICancelModal,
        ActivityFormPanel,
        PhoneCallFormPanel,
        ActivityDetailPanel,
        ActivityDeleteDialog,
        ActivitiesListingMassReschedule,
        ActivitiesMassMarkAsDone,
        ActivitiesListingMassModifyOwner,
        ActivitiesListingMassAssign,
        ActivitiesListingMassDelete,
        MyActivitiesCardConfigDialog,
        ConnectionConsentDialog,
        ActivitiesLinkObjectDialog,
        EmailListingDeleteConfirmDialog,
        AutomationDeleteDialog: () =>
            import('vcomponents/automation/listing/AutomationDeleteDialog.vue'),
        CreateProgressInvoiceBlockByDraftDialog: () =>
            import(
                'vcomponents/documents/invoicing/dialogs/CreateProgressInvoiceBlockByDraftDialog.vue'
            ),
        DialogValidateProgressInvoice: () =>
            import('vcomponents/documents/invoices/DialogValidateProgressInvoice.vue'),
        DocumentHasProgressInvoiceDialog: () =>
            import('vcomponents/documents/invoices/DocumentHasProgressInvoiceDialog.vue'),
        CancelProgressInvoiceDialog: () =>
            import('vcomponents/documents/invoices/DialogCancelProgressInvoice.vue'),
        AlertDialog,
        DialogMissingFeaturesProgressInvoice: () =>
            import('vcomponents/documents/invoices/DialogMissingFeaturesProgressInvoice.vue'),
        DialogProgressInvoiceSelectType: () =>
            import('vcomponents/documents/invoices/DialogProgressInvoiceSelectType.vue'),
        ContactPanel: () => import('vcomponents/contact/ContactPanel/ContactPanel.vue'),
        DocFormErrorDialog: () => import('vcomponents/common/document/DocFormErrorDialog.vue'),
        DialogDocumentNotAuthorized: () =>
            import('vcomponents/common/document/DialogDocumentNotAuthorized.vue'),
    },
    props: [],
    data() {
        return {
            showFeatureModal: true,
        };
    },
    computed: {
        ...popupPanelMapState({
            opportunity: 'opportunityForm',
            address: 'addressForm',
            customfield: 'customfieldForm',
            document: 'documentPreview',
            emailOnboarding: 'emailOnboarding',
            emailConnectionfailed: 'emailConnectionfailed',
            addRecurringTerm: 'addRecurringTerm',
            changeOwner: 'changeOwner',
            changeGenerationMode: 'changeGenerationMode',
            documentValidation: 'documentValidation',
            avatarUploader: 'avatarUploader',
            popupAprilTeamPosition: 'popupAprilTeamPosition',
            transferTransactionForm: 'transferTransactionForm',
            calendarView: 'calendarView',
            staffForm: 'staffForm',
            popupQuotaLimit: 'popupQuotaLimit',
            popupMailchimpSettings: 'popupMailchimpSettings',
            popupMailjetSettings: 'popupMailjetSettings',
            popupThirdForm: 'popupThirdForm',
            popupWarningThirdForm: 'popupWarningThirdForm',
            popupMassEditPrefs: 'popupMassEditPrefs',
            popupMassEditVatMode: 'popupMassEditVatMode',
            popupSchedulerSettings: 'popupSchedulerSettings',
            esignPopupProvider: 'esignPopupProvider',
            popupManagerPaymentCard: 'popupManagerPaymentCard',
            corp2FAToggle: 'corp2FAToggle',
            backupCodes2FA: 'backupCodes2FA',
            deactivate2FA: 'deactivate2FA',
            removeTrustedDevice: 'removeTrustedDevice',
            activate2FAProvider: 'activate2FAProvider',
            adyenPopup: 'adyenPopup',
            cashflowPopupWarning: 'cashflowPopupWarning',
            popupCheckSendingEmail: 'popupCheckSendingEmail',
            importDetailPopup: 'importDetailPopup',
            importRevertPopup: 'importRevertPopup',
            importCancelPopup: 'importCancelPopup',
            onboardingScreenPanel: 'onboardingScreenPanel',
            featureModal: 'featureModal',
            aiCancelModal: 'aiCancelModal',
            activityFormPanel: 'activityFormPanel',
            phoneCallFormPanel: 'phoneCallFormPanel',
            activityDetailPanel: 'activityDetailPanel',
            activityDeleteDialog: 'activityDeleteDialog',
            activitiesListingMassModifyOwner: 'activitiesListingMassModifyOwner',
            activitiesListingMassReschedule: 'activitiesListingMassReschedule',
            popupMarkPhoneCallDone: 'popupMarkPhoneCallDone',
            activitiesMassMarkAsDone: 'activitiesMassMarkAsDone',
            activitiesListingMassAssign: 'activitiesListingMassAssign',
            activitiesListingMassDelete: 'activitiesListingMassDelete',
            myActivitiesCardConfigDialog: 'myActivitiesCardConfigDialog',
            connectionConsentDialog: 'connectionConsentDialog',
            activitiesLinkObjectDialog: 'activitiesLinkObjectDialog',
            alert: 'alert',
            createProgressInvoiceBlockByDraftDialog: 'createProgressInvoiceBlockByDraftDialog',
            dialogValidateProgressInvoice: 'dialogValidateProgressInvoice',
            cancelProgressInvoiceDialog: 'cancelProgressInvoiceDialog',
            emailDeleteConfirmDialog: 'emailDeleteConfirmDialog',
            documentHasProgressInvoiceDialog: 'documentHasProgressInvoiceDialog',
            dialogMissingFeaturesProgressInvoice: 'dialogMissingFeaturesProgressInvoice',
            dialogProgressInvoiceSelectType: 'dialogProgressInvoiceSelectType',
            automationDeleteDialog: 'automationDeleteDialog',
            docFormErrorDialog: 'docFormErrorDialog',
            documentNotAuthorized: 'documentNotAuthorized',
            contactPanel: 'contactPanel',
        }),
    },
    methods: {
        ...popupPanelMapActions(['close']),
        validateDateTyped(date) {
            if (
                !date.isValid() ||
                (this.calendarOptions?.minDate && date.isBefore(this.calendarOptions.minDate)) ||
                (this.calendarOptions?.maxDate && date.isAfter(this.calendarOptions.maxDate)) ||
                (this.calendarOptions?.disablePast && date.isBefore(dayjs())) ||
                this.calendarOptions?.datesDisabled?.includes(date.format(FORMAT_DATE_CALENDAR)) ||
                this.calendarOptions?.disableWeekDays?.includes(date.day())
            ) {
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.compass-dialog {
    z-index: 1000 !important;
}
.popup-panel {
    .el-dialog {
        color: $gray-100;
        margin-top: 60px;
        text-align: left;
        width: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        &:not(.is-fullscreen) {
            max-width: 480px;
        }
        .el-dialog__wrapper {
            padding: 16px;
        }

        .el-dialog__header {
            padding: 24px 48px 16px 16px;
            @media only screen and (min-width: 550px) {
                padding: 32px 64px 24px 32px;
            }
            .el-dialog__title {
                color: $gray-100;
                font-size: 20px;
                font-weight: 700;
            }
            .el-dialog__headerbtn {
                border-radius: 4px;
                height: 24px;
                right: 16px;
                top: 24px;
                width: 24px;
                @media only screen and (min-width: 550px) {
                    right: 32px;
                    top: 32px;
                }
                &:hover {
                    background: rgba($primary-50, 0.1);
                }

                .el-dialog__close {
                    color: $gray-100;
                }
            }
        }

        .el-dialog__body {
            color: $gray-100;
            padding: 0 16px 24px;
            word-break: keep-all;
            @media only screen and (min-width: 550px) {
                padding: 0 32px 24px;
            }
        }

        .el-dialog__footer {
            button + button {
                margin-left: 16px;
            }
        }

        .dialog-footer {
            display: flex;
            justify-content: flex-end;
        }
    }
}

.compass-dialog {
    z-index: 1000 !important;
}

#popupAgenda .el-dialog {
    max-width: 1080px;
}

.nav.toggle-hover > li {
    &:hover .dropdown-menu {
        display: block;
    }
}
</style>
